// extracted by mini-css-extract-plugin
export var appButton = "NewFooterV2-module--appButton--MOGS-";
export var appButtons = "NewFooterV2-module--appButtons--QBwHQ";
export var contactIcon = "NewFooterV2-module--contactIcon--GNbF1";
export var contactInfo = "NewFooterV2-module--contactInfo--xSgCW";
export var contactLink = "NewFooterV2-module--contactLink--FUJX9";
export var copyright = "NewFooterV2-module--copyright--0Vj29";
export var footerBottom = "NewFooterV2-module--footerBottom--7RXa6";
export var footerContent = "NewFooterV2-module--footerContent--4AqYw";
export var footerMiddle = "NewFooterV2-module--footerMiddle--7EZGg";
export var footerTopDesktop = "NewFooterV2-module--footerTopDesktop--d+wZW";
export var footerWrapper = "NewFooterV2-module--footerWrapper--dw00I";
export var legalLink = "NewFooterV2-module--legalLink--SBlrE";
export var legalLinks = "NewFooterV2-module--legalLinks--vBOWX";
export var logoImage = "NewFooterV2-module--logoImage--O2CE6";
export var logoRight = "NewFooterV2-module--logoRight--+4nKF";
export var navLink = "NewFooterV2-module--navLink--tC8Ot";
export var navLinksDesktop = "NewFooterV2-module--navLinksDesktop--QBA7M";
export var navLinksMobile = "NewFooterV2-module--navLinksMobile--xs1Az";
export var separator = "NewFooterV2-module--separator--WIlGc";
export var socialAppsColumn = "NewFooterV2-module--socialAppsColumn--qIGfJ";
export var socialIcon = "NewFooterV2-module--socialIcon--CVPyI";
export var socialIconImage = "NewFooterV2-module--socialIconImage--piHSL";
export var socialIcons = "NewFooterV2-module--socialIcons--cEdxw";